import { render, staticRenderFns } from "./Children.vue?vue&type=template&id=871eabd6&scoped=true"
import script from "./Children.vue?vue&type=script&lang=ts"
export * from "./Children.vue?vue&type=script&lang=ts"
import style0 from "./Children.vue?vue&type=style&index=0&id=871eabd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871eabd6",
  null
  
)

export default component.exports